<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('customers')"
      :columns="columns"
      :column_search="true"
      resource_url="/customer/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <customer-modal ref="customer_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import CustomerModal from "./customer_modal/Index.vue";

export default {
  name: "CustomersDatatable",
  components: { GenericTable, CustomerModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("phone"),
          searchable: false,
          width: "20%",
          data: (row) => {
            return row.phone || "";
          },
        },
        {
          title: v.$t("email"),
          searchable: false,
          width: "20%",
          data: (row) => {
            return row.email || "";
          },
        },
        {
          title: v.$t("balance"),
          searchable: false,
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row.account, null, 2)}</pre>`;
            if (
              row.account &&
              row.account.account &&
              row.account.account.balance
            ) {
              return format_currency(row.account.account.balance);
            } else {
              return "";
              // return v.$t("no account");
            }
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.customer_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete customer?"),
                    v,
                    () => {
                      del("/customer", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.customer_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
